import * as urlTemplate from 'url-template';

import { PassengerArrangement, PassengerType } from '@shared/base-search-bar/entities/passenger-arrangement';
import { FlightType } from '@search-bar/entities/flight-type';
import { FLIGHT_CLASS } from '@search-bar/constants/search-bar.constants';
import { AlertResponse } from '@shared/widgets/entities/alerts';
import { invertAlertDateBoundFormat } from '@shared/widgets/mappers/alert-date-format.mapper';

const passengerDefault: PassengerArrangement[] = [
  {
    id: PassengerType.ADULTS,
    quantity: 1
  },
  {
    id: PassengerType.CHILDREN,
    quantity: 0
  },
  {
    id: PassengerType.INFANTS,
    quantity: 0
  }
];

export function flightResultsUrlMapper(alert: AlertResponse): string {
  if (alert.oneway) return mapForOneWay(alert);
  else return mapForRoundTrip(alert);
}

function mapForOneWay(data: AlertResponse): string {
  return urlTemplate
    .parse('{flight_type}/{flight_class}/{departure}/{arrival}/{departure_date}' +
      '/{adults}/{children}/{infants}/{baggageIncluded}/{airline}')
    .expand({
      flight_type: FlightType.ONEWAY.toLowerCase(),
      flight_class: FLIGHT_CLASS.ECONOMY,
      departure: data.departure,
      arrival: data.arrival,
      departure_date: invertAlertDateBoundFormat(data.outbound_min, !!data.flex_dates),
      airline: 'null',
      baggageIncluded: 'false',
      ...mapPassengers(passengerDefault)
    });
}

function mapForRoundTrip(data: AlertResponse): string {
  return urlTemplate.
    parse('{flight_type}/{flight_class}/{departure}/{arrival}/{departure_date}/'
      + '{arrival_date}/{adults}/{children}/{infants}/{baggageIncluded}/{airline}')
    .expand({
      flight_type: FlightType.ROUNDTRIP.toLowerCase(),
      flight_class: FLIGHT_CLASS.ECONOMY,
      departure: data.departure,
      arrival: data.arrival,
      departure_date: invertAlertDateBoundFormat(data.outbound_min, !!data.flex_dates),
      arrival_date: invertAlertDateBoundFormat(data.inbound_max, !!data.flex_dates, true),
      airline: 'null',
      baggageIncluded: 'false',
      ...mapPassengers(passengerDefault)
    });
}

function mapPassengers(passengers: PassengerArrangement[]): { adults: number, children: number, infants: number } {
  const adults = passengers.find(passenger => passenger.id.toUpperCase() === PassengerType.ADULTS);
  const children = passengers.find(passenger => passenger.id.toUpperCase() === PassengerType.CHILDREN);
  const infants = passengers.find(passenger => passenger.id.toUpperCase() === PassengerType.INFANTS);
  return {
    adults: adults ? adults.quantity : 0,
    children: children ? children.quantity : 0,
    infants: infants ? infants.quantity : 0
  };
}
